export default {
  name: "LoginComponent",
  data() {
    return {
      form: {
        login: "",
        password: ""
      },
      error: "",
      loading: false
    };
  },
  methods: {
    login() {
      this.error = "";
      this.loading = true;
      const {
        login,
        password
      } = this.form;
      this.$store.dispatch("login", {
        login,
        password
      }).then(status => {
        if (status === 201) {
          console.log("Connexion réussie");
          this.$router.push("/Menu");
        } else {
          throw new Error("Identifiants invalides");
        }
      }).catch(err => {
        this.error = "Échec de la connexion : email ou mot de passe incorrect.";
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};